module.exports = __webpack_public_path__ + "static/img/Comscore-Default.ec2d67d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fileTypes/Comscore-Default.png
// module id = 1594
// module chunks = 0